// @ts-check

// We can disable prop-types since the props are typed out below.
/* eslint-disable react/prop-types */

import { Select } from '@tkww/orion-web-ds-input';
import { GridColumn, GridRow } from '@tkww/orion-web-ds-structure';
// biome-ignore lint/correctness/noUnusedImports: Used in JSDoc type annotation
import { ListboxController } from '@tkww/orion-web-lib-listbox';
import React from 'react';
import { awardsInfo } from '../../../../../utils/awardsInfo';

import Styles from './styles.scss';

const { bow, hof } = awardsInfo();

/**
 * @typedef {Object} AwardTypeProps
 *
 * @property {Bow.AwardType} awardType
 * @property {(awardType: Bow.AwardType) => void} setAwardType
 */

/** @type {React.FC<AwardTypeProps>} */
const AwardType = (props) => {
	const { awardType, setAwardType } = props;

	/** @type {(e: ListboxController.SelectedChangeEvent) => void} */
	const selectAwardType = (e) => {
		const selectedAwardType = e.detail.value === bow.name ? bow : hof;
		setAwardType(selectedAwardType);
	};

	return (
		<GridRow>
			<GridColumn md="6" lg="6" className={Styles.awardSelect}>
				<Select
					onSelectedChange={selectAwardType}
					name="Select a Type of Award"
					selected={awardType.name}
					options={[{ value: bow.name }, { value: hof.name }]}
				/>
			</GridColumn>
		</GridRow>
	);
};

export default AwardType;
